export default {
  title: 'v{version}',
  notification: 'Nueva versión <strong>{version}</strong> disponible.</br>Actualiza la página.',

  notifications: {
    copied: 'Versión copiada'
  }
}
